import { IconButton, IconButtonProps } from "@material-ui/core";
import { MoreVert } from "@material-ui/icons";
import { FC } from "react";

export const Opener: FC<IconButtonProps> = (props) => (
	<IconButton {...props} size="small">
		<MoreVert color="primary" />
	</IconButton>
);
